<!--
帖子回复内容
-->
<template>
    <va-inner-loading :loading="isLoading" style="width: 100%" color="primary">
        <va-card>
            <va-card-content
                class="ant-row ant-row-space-between"
                v-for="(item, index) in msgList"
                :key="index"
            >
                <div class="ant-row flex xs11 md11" style="padding: 0">
                    <div class="msg-user-img flex xs1 md1" style="padding: 0">
                        <img
                            :src="
                                item.HeadPic ||
                                require('@/static/images/headDefault.jpg')
                            "
                            alt=""
                        />
                    </div>

                    <div
                        class="ant-space ant-space-vertical flex xs11 md11"
                        style="padding: 0"
                    >
                        <div class="msg-user">
                            <span>#{{ item.RowNum }}</span>
                            <span>·</span>
                            <span>{{ item.alias }}</span>
                            <span>回复于{{ item.CreateTime }}</span>
                        </div>
                        <div
                            class="replyto-content"
                            v-if="item.ReplyTo != null"
                        >
                            <div class="msg-user">
                                <span>对#{{ item.ReplyTo.RowNum }}</span>
                                <span>·</span>
                                <span>{{ item.ReplyTo.alias }}</span>
                                <span>回复于{{ item.ReplyTo.CreateTime }}</span>
                            </div>
                            <div
                                class="ant-row ant-row-space-between comment-reply"
                                v-if="item.ReplyTo.IsDel != 1"
                            >
                                <div
                                    :class="[
                                        'reply-text',
                                        item.fold ? '' : 'text-off',
                                    ]"
                                    v-html="item.ReplyTo.ReplyCont"
                                ></div>
                                <div
                                    class="fold"
                                    @click="item.fold = !item.fold"
                                >
                                    {{ item.fold ? "展开" : "收起" }}
                                </div>
                            </div>
                            <div
                                class="ant-row ant-row-space-between comment-reply"
                                v-else
                            >
                                <span class="reply-text">回复已删除</span>
                            </div>
                            <a
                                class="compile"
                                style="text-align: left"
                                target="_blank"
                                :href="item.ReplyTo.FilePath"
                                v-if="item.ReplyTo.FilePath"
                            >
                                <va-icon
                                    class="icon-left input-icon"
                                    name="file_download"
                                />
                                {{ item.ReplyTo.FileName }}</a
                            >
                        </div>
                        <div v-html="item.ReplyCont"></div>
                        <a
                            class="compile"
                            style="text-align: left"
                            target="_blank"
                            :href="item.FilePath"
                            v-if="item.FilePath"
                        >
                            <va-icon
                                class="icon-left input-icon"
                                name="file_download"
                            />
                            {{ item.FileName }}</a
                        >
                    </div>
                </div>
                <!-- 回复图标 -->
                <div class="flex xs1 md1" style="padding: 0">
                    <va-icon
                        class="icon-left input-icon msg-hover"
                        @click="replyClick(item)"
                        name="reply"
                    />
                    <!-- <va-icon :class="[item.isLike ? 'accollect-btn' : 'collect-btn','msg-hover']" @click="item.isLike = !item.isLike" v-model:value="item.isLike" name="favorite"/> -->
                    <!-- <span style="margin-left:5px;">5</span> -->
                    <div
                        class="compile"
                        @click="delArticleReply(item.ID)"
                        :data-delid="item.ID"
                        v-if="item.Creator == $store.state.userID"
                        style="margin-left: 10px"
                    >
                        删除
                    </div>
                </div>
            </va-card-content>
            <va-card-content v-if="msgList.length < 1">
                暂无更多数据
            </va-card-content>
            <va-card-content>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="findReply"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </va-card-content>
            <va-card-content>
                <template #default>
                    <div class="reply-user" v-if="replyUserDetail.isReply">
                        回复<span>#{{ replyUserDetail.RowNum }}</span> ·
                        {{ replyUserDetail.alias }}
                        <va-icon
                            class="icon-left input-icon"
                            @click="clearReply"
                            name="clear"
                        />
                    </div>
                    <vxe-form
                        :data="formInput.formData"
                        v-if="isReplyProps != '1'"
                    >
                        <vxe-form-item
                            title=""
                            field="contents"
                            span="24"
                            :item-render="{}"
                        >
                            <template #default="">
                                <div>
                                    <div id="editor-wrapper">
                                        <articleEditor
                                            v-model="articleContent"
                                            :mode="'simple'"
                                        ></articleEditor>
                                    </div>
                                </div>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item style="padding: 0">
                            <template #default="{ data }">
                                <div>
                                    <vxe-button
                                        status="primary"
                                        @click="insertEvent(false)"
                                        >选择文件</vxe-button
                                    >

                                    <span style="margin-left: 10px">{{
                                        data.fileUrlName
                                    }}</span>
                                    <span style="margin-left: 10px">{{
                                        data.FileName
                                    }}</span
                                    ><span
                                        class="del-btn"
                                        v-if="data.fileUrlName != ''"
                                        @click="delClick"
                                        >删除</span
                                    >
                                </div>
                            </template>
                        </vxe-form-item>
                    </vxe-form>

                    <!-- <va-button class="flex xs14 msg-submit" @click="publish" :rounded="false" text-color="#ffffff">提交回复</va-button> -->
                    <vxe-button
                        :loading="submitLoad"
                        v-if="isReplyProps != '1'"
                        @click="publish"
                        class="msg-submit"
                        status="primary"
                        content="提交回复"
                    ></vxe-button>
                </template>
            </va-card-content>
            <a name="a1"></a>
        </va-card>
    </va-inner-loading>
</template>
<script>
import {
    computed,
    defineComponent,
    reactive,
    ref,
    getCurrentInstance,
} from "vue";
import postsMinxin from "../postsMinxin.js";
import Qs from "qs";
import articleEditor from "./articleEditor.vue";
import VXETable from "vxe-table";

let editor;
export default {
    mixins: [postsMinxin],
    name: "postsContent",
    props: {
        isReplyProps: {
            type: String,
            default: () => {
                return "";
            },
        },
    },
    components: { articleEditor },
    data() {
        const msgList = reactive([]);
        const formInput = reactive({
            isShow: false,
            editType: "1",
            formData: {
                id: "",
                title: "",
                contents: "",
                active: "",
                creator: "",
                fileUrlName: "",
                fileUrl: "",
                modifier: "",
                type: "2", //感言
            },
        });
        return {
            setStateValue: "",
            replyUserDetail: {},
            activeKey: 1,
            formInput,
            msgList,
            replyValue: {},
            content: "<span>发布于2021-2-26</span>",
            tabsList: [
                "学习资料",
                "学习资料",
                "学习资料",
                "学习资料",
                "学习资料",
            ],
            articleContent: null,
            pushEditorData: "",

            pushEditorHeight: 0,
            submitLoad: false,
            isLoading: false,
        };
    },
    mounted() {
        if (this.$route.query.searcharticle != undefined) {
            this.findReply();
        }
    },
    methods: {
        // getEditorContent(conetntHtml){
        //   this.articleContent = conetntHtml;
        // },
        delClick() {
            this.pushEditorData = "";
            this.formInput.formData.fileUrl = "";
            this.formInput.formData.fileUrlName = "";
        },
        //清除回复用户名
        clearReply() {
            this.replyUserDetail.isReply = false;
        },
        //点击恢复
        replyClick(params) {
            this.replyUserDetail = params;
            this.replyUserDetail.isReply = true;
        },
        //删除回复
        async delArticleReply(delid) {
            const type = await VXETable.modal.confirm(
                "您确定要删除该回复吗?",
                "提示",
                { mask: true }
            );

            if (type === "confirm") {
                let params = {
                    ReplyID: delid,
                    UserID: this.$store.state.userID,
                };
                this.$api.formsAPI
                    .delArticleReply(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });

                            return;
                        }
                        this.findReply();
                        VXETable.modal.message({
                            content: "删除成功！",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //上传附件
        async insertEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fileUrlName = file.name;
                this.formInput.formData.fileUrl = file;
            });
        },
        //获取回复数据
        findReply(articleParams) {
            this.isLoading = true;
            let params = {
                ArticleId: this.$route.query.searcharticle, // ,
                Creator: "",
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
            };
            this.$api.formsAPI
                .getArticleReply(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.msgList = res.data.Data.dataTable;
                    this.msgList.map((item) => {
                        if (item.ReplyCont != null) {
                            item.fold = false;
                        }
                    });
                    console.log(this.msgList);
                    // this.$store.commit('updateSearchData','');
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        exportDataEvent() {
            const $table = this.$refs.xTable1;
            $table.exportData();
        },
        //提交回复
        publish() {
            this.submitLoad = true;
            let searcharticle;
            if (this.$route.query.searcharticle != undefined) {
                searcharticle = this.$route.query.searcharticle;
            } else {
                // VXETable.modal.message({ content: '获取错误！', status: 'warning' })
                return false;
            }
            if (this.articleContent == null || this.articleContent == "") {
                this.submitLoad = false;
                VXETable.modal.message({
                    content: "请填写内容！",
                    status: "warning",
                });
                return false;
            }
            const data = new FormData();
            data.append("ID", "0"); //0 传0或不传
            data.append("ArticleID", searcharticle); //帖子ID
            // data.append('ReplyCont',encodeURI(quill.getHTML()));//回复内容
            data.append("ReplyCont", encodeURIComponent(this.articleContent)); //内容
            data.append("Creator", this.$store.state.userID); //回复人UID
            // data.append('CreateTime',quill.getHTML());//传空或不传
            // data.append('FileName',quill.getHTML());//不用传

            data.append("file", this.formInput.formData.fileUrl); //上传的附件
            if (this.replyUserDetail.isReply) {
                //是否回复回复中的帖子
                data.append("ReplyTo", this.replyUserDetail.ID);
            }
            this.$api.formsAPI
                .addArticleReplyWithFile(data)
                .then((res2) => {
                    if (res2.data.Success == false) {
                        VXETable.modal.alert({
                            content: res2.data.Message,
                            status: "error",
                        });
                        this.submitLoad = false;
                        return;
                    }
                    // quill.setHTML('<p><br></p>');
                    this.replyUserDetail.isReply = false;
                    VXETable.modal.message({
                        content: "回复成功！",
                        status: "success",
                    });

                    this.articleContent = "";
                    this.delClick();
                    this.findReply();
                    this.submitLoad = false;
                })
                .catch((error2) => {
                    VXETable.modal.alert({ content: error2, status: "error" });
                    this.submitLoad = false;
                    console.log(error2);
                });

            // VXETable.modal.message({ content: '发布成功！', status: 'success' })
        },
    },
};
</script>

<style src="../css/antd.css"></style>
<style lang="scss">
.text-off {
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    p:first-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

p {
    margin-bottom: 0 !important;
}

.inner-loading__spinner {
    -webkit-animation: va-icon--spin-animation 1.5s linear infinite;
    animation: va-icon--spin-animation 1.5s linear infinite;
    animation-direction: reverse;
}

@-webkit-keyframes va-icon--spin-animation {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}

@keyframes va-icon--spin-animation {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}
</style>
<style scoped lang="scss">
.reply-user {
    span {
        position: relative;
        padding-right: 10px;
        color: #52bc89;
    }

    i {
        color: rgb(173, 173, 173);
        font-size: 18px !important;
    }
}

.replyto-content {
    padding: 16px 0 16px 22px;
    margin-bottom: 10px;
    width: 540px;
    background: #f7f7f7;
    color: #999;
}

.comment-reply {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 0;

    flex-wrap: nowrap;

    .fold {
        cursor: pointer;
        color: #000;
        display: block;
        z-index: 9999;
        margin-right: 10px;
        font-size: 14px;
    }

    .reply-text {
        display: inline-block;
        width: 435px;
        vertical-align: top;
        line-height: 20px;
        font-size: 14px;
        word-wrap: break-word;
        //   p{
        //   width: 435px;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   white-space: nowrap;
        // }
    }
}

.del-btn {
    margin-left: 10px;
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
}

.compile {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    text-align: right;
    display: inline-block;
    vertical-align: text-top;
}

.msg-submit {
    border-radius: unset;
    margin: 10px 0px 0px auto;
    display: block;
}

::v-deep .vxe-form .vxe-form--item {
    padding: 0;
}

::v-deep .ql-container {
    height: 200px;
}

.collect-btn {
    color: #bfbfbf;
    cursor: pointer;
}

.msg-hover {
    // margin-left: 6px;
    color: #bfbfbf;
    font-size: 22px !important;
    cursor: pointer;

    &:hover {
        color: #ffd43a;
    }
}

.accollect-btn {
    //#ffd43a
    cursor: pointer;
    color: #ffd43a;
}

.msg-user {
    span:nth-child(1) {
        color: #52bc89;
        font-size: 14px;
    }

    span:nth-child(2) {
        margin: 0 5px;
    }

    span:nth-child(3) {
        color: #afafaf;
        font-size: 13px;
        margin-right: 6px;
    }

    span:nth-child(4) {
        color: #afafaf;
        font-size: 13px;
    }
}

.like-img img {
    width: 28px;
    height: 28px;
    display: inline-block;
    margin-right: 6px;
    border-radius: 100%;
}

.content-tabs {
    display: inline-block;
    padding: 6px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    vertical-align: top;
    font-size: 14px;
    color: #333;
    background-color: #eef4fa;
    -webkit-border-radius: 1px;
    -moz-border-radius: 1px;
    border-radius: 1px;
}

.user-img {
    width: 46px;
    height: 46px;
    margin-right: 10px;
    border-radius: 100%;
}

.msg-user-img {
    img {
        width: 46px;
        height: 46px;
        margin-right: 10px;
        border-radius: 100%;
    }
}

.boutique {
    margin-bottom: 0;
    align-items: end;
    display: inline-block;
    position: relative;
}

.boutique::after {
    content: "精";
    display: block;
    position: absolute;
    right: -20px;
    top: 0;
    line-height: 12px;
    text-align: center;
    padding: 3px;
    border-radius: 4px;
    font-size: 12px;
    color: #ffffff;
    background: #fa8429;
}

.user-msg {
    margin-right: 20px;
    color: #262626;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
        color: #ccc;
        font-size: 13px;
    }
}

.msg-submit {
    border-radius: unset;
    margin: 10px 0px 0px auto;
    display: block;
}
#editor-wrapper .w-e-full-screen-container {
    z-index: 99999 !important;
}
</style>
